
import React from 'react';
import { View } from '@coinscrap/webapp-core';

import InputLabel from 'components/InputLabel/InputLabel';

import { getCurrency } from 'helpers/currency';

export const Capital = ({
	capital,
	setCapital,
	setIsValidCapital,
	otherCapital,
	setOtherCapital,
	capitalMaximum,
	capitalMinimum,
	capitalList,
}) => {
	return (
		<View inputFreeRowSt>
			<InputLabel
				type="select"
				showLabel={false}
				value={capital || 100000}
				onChange={(e) => {
					const newCapital = e.target.value || '';
					setCapital(newCapital);
					setIsValidCapital(
						newCapital === 'Otros'
							? otherCapital !== '' &&
							otherCapital <= capitalMaximum &&
							otherCapital >= capitalMinimum
							: newCapital !== '' &&
							newCapital <= capitalMaximum &&
							newCapital >= capitalMinimum,
					);
					setOtherCapital(0);
				}}
				selectOptions={capitalList.map((item) => {
					return {
						label: isNaN(item) ? item : getCurrency(item),
						value: item,
					};
				})}
			/>
		</View>
	);
};
